import { Controller } from "stimulus"

// Wraps a <details class="expandable-list"> element to support a "Show less"
// trigger placed in the body (outside of <summary>). Clicking the trigger
// closes the <details> by removing its open attribute.
//
// Usage:
//   <details class="expandable-list" data-controller="expandable-list">
//     <summary>… + N more …</summary>
//     <span>…tail content…</span>
//     <button type="button" data-action="click->expandable-list#close">
//       Show less
//     </button>
//   </details>
export default class extends Controller {
  close(event) {
    event.preventDefault()
    this.element.removeAttribute("open")
  }
}
